import React, { useState } from 'react';
import { createBulkAgents } from '../services/api'; // Adjust the path as necessary
import '../css/styles.css'; // Import styles

const BulkAgentForm = () => {
  const [bulkFile, setBulkFile] = useState(null);

  // Handle bulk registration
  const handleBulkSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('file', bulkFile);

    // Get ownerId from local storage and append it to the form data
    const ownerId = localStorage.getItem("userId");
    data.append('ownerId', ownerId);

    try {
      await createBulkAgents(data); // API call
      alert('Agents registered successfully!');
      setBulkFile(null);
    } catch (err) {
      console.error(err);
      alert('Failed to register agents. Please try again.');
    }
  };

  // Handle bulk file input change
  const handleBulkFileChange = (e) => {
    setBulkFile(e.target.files[0]);
  };

  return (
    <div className="container">
      <form onSubmit={handleBulkSubmit} encType="multipart/form-data">
        <label>
          Bulk Register Agents:
          <input
            type="file"
            name="bulkFile"
            onChange={handleBulkFileChange}
            accept=".xlsx, .xls"
            required
          />
        </label>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default BulkAgentForm;